import React, { useEffect } from 'react';

import { PublicCertificatePaymentWrapper } from '@components';
import { scrollTop } from '@share/utils';

import styles from './styles.module.scss';

export function PublicCertificatePaymentPage(): React.ReactElement {
  useEffect(() => {
    scrollTop();
  }, []);

  return (
    <div className={styles.root}>
      <PublicCertificatePaymentWrapper />
    </div>
  );
}
